import { UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { INotification, IUnreadCount } from "../library/models/notification";
import { IPagedQueryOptions } from "../library/models/page";
import { BaseService } from "./baseService";

/** The caller's own bell. No method takes a user: every route is pinned to the session. */
export class NotificationsService extends BaseService {
    /** Newest first, a page at a time. Asked for only while the bell is open. */
    getNotifications(size: number): IPagedQueryOptions<INotification> {
        return this.createGetInfiniteQuery<INotification>('/notifications', size);
    }

    /** The number on the bell, which the header polls. */
    getUnreadCount(): UseQueryOptions<IUnreadCount, Error> {
        return this.createGetQuery<IUnreadCount>('/notifications/unread-count');
    }

    markReadMutation(): UseMutationOptions<void, Error, number> {
        return {
            mutationFn: (notificationId: number): Promise<void> =>
                this.put<void>(`/notifications/${notificationId}/read`),
        };
    }

    markAllReadMutation(): UseMutationOptions<void, Error, void> {
        return {
            mutationFn: (): Promise<void> => this.put<void>('/notifications/read-all'),
        };
    }
}
